/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Item,
  Item$inboundSchema,
  Item$Outbound,
  Item$outboundSchema,
} from "./item.js";
import {
  Usage,
  Usage$inboundSchema,
  Usage$Outbound,
  Usage$outboundSchema,
} from "./usage.js";

export type CompactedResponse = {
  id: string;
  createdAt: number;
  object: "response.compaction";
  output: Array<Item>;
  usage: Usage;
};

/** @internal */
export const CompactedResponse$inboundSchema: z.ZodType<
  CompactedResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  created_at: z.number().int(),
  object: z.literal("response.compaction"),
  output: z.array(Item$inboundSchema),
  usage: Usage$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "created_at": "createdAt",
  });
});
/** @internal */
export type CompactedResponse$Outbound = {
  id: string;
  created_at: number;
  object: "response.compaction";
  output: Array<Item$Outbound>;
  usage: Usage$Outbound;
};

/** @internal */
export const CompactedResponse$outboundSchema: z.ZodType<
  CompactedResponse$Outbound,
  z.ZodTypeDef,
  CompactedResponse
> = z.object({
  id: z.string(),
  createdAt: z.number().int(),
  object: z.literal("response.compaction"),
  output: z.array(Item$outboundSchema),
  usage: Usage$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    createdAt: "created_at",
  });
});

export function compactedResponseToJSON(
  compactedResponse: CompactedResponse,
): string {
  return JSON.stringify(
    CompactedResponse$outboundSchema.parse(compactedResponse),
  );
}
export function compactedResponseFromJSON(
  jsonString: string,
): SafeParseResult<CompactedResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompactedResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompactedResponse' from JSON`,
  );
}
